export default {
    despachos: {
        titulo: "Fuel & Lubricant Dispatch",
        nuevo: "New dispatch",
        editar: "Edit dispatch",
        matricula: "Plate",
        responsable: "Responsible",
        fechaIni: "Start date",
        fechaFin: "End date",
        fecha: "Date",
        kmsHs: "Kms/Hs",
        gasoil: "Fuel",
        aceiteHidraulico: "Hydraulic oil",
        aceiteMotor: "Engine oil",
        cambioAceite: "Oil change performed",
        otros: "Other",
        tipoEquipo: "Equipment type",
        marca: "Brand",
        modelo: "Model",
        obra: "Site",
        ultimosDespachos: "Latest dispatches",
        confirmar: "Confirm",
        eliminar: "Delete",
        pregEliminar: "Do you want to delete this dispatch?",
        eliminarTitulo: "Delete dispatch",
        importar: "Import",
        importarTitulo: "Import dispatches from dispenser Excel",
        seleccionarArchivo: "Dispenser file (.xlsx)",
        analizarArchivo: "Analyze file",
        confirmarImportacion: "Confirm import",
        filasLeidas: "Rows read",
        filasImportables: "To import",
        filasDuplicadas: "Duplicates (skipped)",
        filasConError: "With errors (skipped)",
        importadosOk: "{n} dispatches imported",
        fila: "Row",
        estado: "Status",
        motivo: "Reason",
        estadoOk: "To import",
        estadoDuplicado: "Duplicate",
        estadoError: "Error",
    },
    planilla: {
        titulo: "Vehicle Fuel & Oil Control",
        resumenMensual: "Monthly summary",
        promedioGasoil: "Fuel average",
        tipo: "Type",
        litros: "Liters",
        totales: "TOTALS",
        valoresTotalesAl: "Totals as of",
        ultimoCambio: "Last oil change",
        proximoCambio: "Next oil change",
        cambio: "Interval",
        actual: "Current",
        proximo: "Next",
        estado: "Status",
        mes: "Month",
        kms: "Kms",
        kmsLts: "Kms/Lts",
    },
    cambiosAceite: {
        titulo: "Vehicles Due for Oil Change",
        vehiculo: "Vehicle",
        ultimoCambio: "Last oil change",
        actual: "Current",
        proximoCambio: "Next oil change",
        vencido: "Overdue",
    },
    alertas: {
        titulo: "Fuel Consumption Out of Range",
        mes: "Month",
        vehiculo: "Vehicle",
        consumo: "Out-of-range consumption",
        consumoMinimo: "Minimum consumption",
        consumoMaximo: "Maximum consumption",
        eliminar: "Delete alert",
        pregEliminar: "Do you want to delete this alert?",
    },
    proximosMantenimientos: {
        titulo: "Upcoming Maintenance",
        equipo: "Equipment",
        plan: "Maintenance plan",
        actual: "Current Kms/Hs",
        proximo: "Next maintenance",
        crearServicio: "Create service",
        servicioCreado: "Service created successfully",
        enProceso: "Service in progress",
    },
    dashboard: {
        cambioAceite: "OIL CHANGE",
        proximoCambio: "Next oil change",
        ultimoCambio: "Last oil change",
        kmsHs: "Kms/Hs",
        estado: "Status",
    },
};
